import * as React from "react"
import { useTranslation } from 'react-i18next'
import { cn } from "@/lib/utils"

const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, children, ...props }, ref) => {
  const { t } = useTranslation()
  return (
    <label
      ref={ref}
      className={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className
      )}
      {...props}
    >
      {typeof children === 'string' ? t(children) : children}
    </label>
  )
})
Label.displayName = "Label"

export { Label } 